import React, { useEffect } from 'react';

const PipedriveForm = () => {
  useEffect(() => {
    // Remove any existing script to avoid conflicts
    const existingScript = document.getElementById('pipedrive-webforms-script');
    if (existingScript) {
      existingScript.remove();
    }
    
    // Create and add the script fresh
    const script = document.createElement('script');
    script.src = 'https://webforms.pipedrive.com/f/loader';
    script.id = 'pipedrive-webforms-script';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div 
      className="pipedriveWebForms" 
      data-pd-webforms="https://webforms.pipedrive.com/f/6WdO6aN71Toiq7vvDw511qa9gtjiDawJtyC6jLvlPTYW3bXczoaKN02Id6N8qrrHUv"
    ></div>
  );
};

export default PipedriveForm;
